import { Box, CircularProgress, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";
import CustomMonthPicker from "../../../components/MonthPicker";
import { observer } from "mobx-react-lite";
import { useStores } from "../../../../../models/helpers/useStores";
import moment from "moment";
import { useEffect } from "react";
import { Card } from "../../../components/Card";
import { Colors } from "../../../../../theme";
import NoDataFound from "../../../components/NoDataFound";
import { useTranslation } from "react-i18next";

const MonthlyReport = observer(() => {
  const {
    checklistReportStore: {
      isGetLoading,
      filterMonthly,
      summaryCheckList,
      listSummaryReport,
    },
  } = useStores();
  const {t} = useTranslation() as any

  useEffect(() => {
    summaryCheckList({
      start_time: filterMonthly.start_time ?? moment().startOf("month").unix(),
      end_time: filterMonthly.end_time ?? moment().endOf("month").unix(),
      page: 1,
      limit: 100,
    });
  }, []);

  return (
    <Box>
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          width: "100%",
        }}
      ></Box>
      <CustomMonthPicker
        start_time={filterMonthly.start_time}
        onChange={(st, et) =>
          summaryCheckList({
            ...filterMonthly,
            start_time: st,
            end_time: et,
            page: 1,
            limit: 100,
          })
        }
      />
      {isGetLoading && <CircularProgress size={24} />}
      {!isGetLoading && (
        <>
          <Typography
            style={{
              color: "gray",
              marginTop: "16px",
              marginBottom: "8px",
            }}
            variant="h5"
          >
            {t("03_01_sumary").toUpperCase()}
          </Typography>
          <Card
            disabled
            ContentComponent={
              <Typography variant="h5">{t("26_01_total_checklists")}</Typography>
            }
            RightComponent={
              <Typography variant="h5" color={Colors.primary}>
                {listSummaryReport?.total_checklist}
              </Typography>
            }
          />
          <Card
            disabled
            ContentComponent={<Typography variant="h5">{t("26_01_total_tasks")}</Typography>}
            RightComponent={
              <Typography variant="h5" color={Colors.primary}>
                {listSummaryReport?.total}
              </Typography>
            }
          />
          <Card
            disabled
            ContentComponent={
              <Typography variant="h5">{t("26_01_tasks_completed")}</Typography>
            }
            RightComponent={
              <Typography variant="h5" color={Colors.primary}>
                {listSummaryReport?.completed !== undefined &&
                listSummaryReport?.total !== undefined &&
                listSummaryReport.total > 0
                  ? `${listSummaryReport.completed} (${(
                      (listSummaryReport.completed / listSummaryReport.total) *
                      100
                    ).toFixed(2)}%)`
                  : "0 (0%)"}
              </Typography>
            }
          />
          <Card
            disabled
            ContentComponent={
              <Typography variant="h5">{t("26_01_tasks_pending")}</Typography>
            }
            RightComponent={
              <Typography variant="h5" color={Colors.primary}>
                {listSummaryReport?.in_completed !== undefined &&
                listSummaryReport?.total !== undefined &&
                listSummaryReport.total > 0
                  ? `${listSummaryReport.in_completed} (${(
                      (listSummaryReport.in_completed /
                        listSummaryReport.total) *
                      100
                    ).toFixed(2)}%)`
                  : "0 (0%)"}
              </Typography>
            }
          />

          <Typography
            style={{
              color: "gray",
              marginTop: "16px",
              marginBottom: "8px",
            }}
            variant="h5"
          >
            {t("26_01_top_performers").toUpperCase()}
          </Typography>
          {listSummaryReport?.tops && listSummaryReport.tops.length > 0 ? (
            listSummaryReport.tops.map((item, index) => (
              <Card
                key={index}
                disabled
                ContentComponent={
                  <Typography variant="h5">{item.fullname}</Typography>
                }
                RightComponent={
                  <Typography variant="h5" color={Colors.primary}>
                    {item?.percent ?? 0}%
                  </Typography>
                }
              />
            ))
          ) : (
            <NoDataFound />
          )}
        </>
      )}
      <Outlet />
    </Box>
  );
});

export default MonthlyReport;
